import { AnalyticsEvent } from '../models';

export class RewardsPageLoadEvent implements AnalyticsEvent {
    name = 'RewardsPageLoadEvent';

    constructor(public readonly pageName: string) {}
}